import dayjs from 'dayjs'

export const sortEvents = eventsList => {
    return eventsList.sort(
      (a, b) => dayjs(a.node.when).unix() - dayjs(b.node.when).unix()
    )
  }